<template>
  <div id="app">
    <div id="befender">
      <app-header />
      <router-view />
      <transition name="fade">
        <modal-dialog v-if="dialogData" />
      </transition>
      <transition name="fade">
        <app-toast v-if="toastMessage" />
      </transition>
      <transition name="fade">
        <error-dialog v-if="errorData" />
      </transition>
      <transition name="fade">
        <div class="loading-modal"
             v-if="apiLoading">
          <svg x="0px" y="0px" viewBox="0 0 150 150">
            <circle class="loading-inner" cx="75" cy="75" r="60"/>
          </svg>
          <p>Loading</p>
        </div>
      </transition>
      <app-footer />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { EventBus } from '@/lib/event-bus'
import AppHeader from './components/global/AppHeader'
import AppFooter from './components/global/AppFooter'
import ModalDialog from './components/global/ModalDialog'
import AppToast from './components/global/AppToast'
import ErrorDialog from './components/global/ErrorDialog'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'App',
  mixins: [ajaxHandlerMixin],
  components: {
    AppHeader,
    AppFooter,
    ModalDialog,
    AppToast,
    ErrorDialog
  },

  data () {
    return {
      apiLoadingState: {}
    }
  },

  computed: {
    ...mapState(['dialogData', 'errorData', 'toastMessage']),
    ...mapGetters(['userData']),

    apiLoading () {
      return Object.values(this.apiLoadingState).includes(1)
    }
  },

  created () {
    EventBus.$on('onApiLoading', (url, state) => {
      if (state === 1) {
        if (this.apiLoadingState[url] === 0) {
          this.$set(this.apiLoadingState, url, state)
        }
      } else {
        this.$set(this.apiLoadingState, url, state)
      }
    })

    this.clickEventHandler = function () {
      this.setShowPersonalMenu(false)
    }.bind(this)

    this.fetchUserData().catch(this.handleAjaxError)
    this.fetchSwasCategory().catch(this.handleAjaxError)
  },
  mounted () {
    document.documentElement.addEventListener('click', this.clickEventHandler)

    if (process.env.NODE_ENV === 'production') {
      ;(function (w, d, a) {
        w.__beusablerumclient__ = {
          load: function (src) {
            var b = d.createElement('script')
            b.src = src
            b.async = true
            b.type = 'text/javascript'
            d.getElementsByTagName('head')[0].appendChild(b)
          }
        }
        w.__beusablerumclient__.load(a)
      })(window, document, '//rum.beusable.net/script/b160804e144953u53/2ec898c834')
    }
  },
  methods: {
    ...mapActions(['fetchUserData', 'fetchSwasCategory']),
    ...mapMutations(['setShowPersonalMenu'])
  },
  destroyed () {
    document.documentElement.removeEventListener('click', this.clickEventHandler)
  }
}
</script>

<style lang="scss">
@import './assets/css/common.scss';
@import './assets/css/befender.scss';
@import './assets/css/icons.scss';

.loading-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 30px 0 10px;
  width: 140px;
  height: 110px;
  text-align: center;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: rgba(255, 255, 255, 0.8);

  p {
    margin-top: 10px;
  }

  svg {
    z-index: 1;
    width: 54px;
    height: 54px;
    animation: loading 3s linear infinite;
    margin: 0 auto;

    .loading-inner {
      stroke: {
        dashoffset: 0;
        dasharray: 300;
        width: 20;
        miterlimit: 10;
        linecap: round;
      }

      animation: loading-circle 2s linear infinite;
      stroke: #ec0047;
      fill: transparent;
    }

    @keyframes loading {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes loading-circle {
      0% {
        stroke-dashoffset: 0
      }
      100% {
        stroke-dashoffset: -600;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
  z-index: 10;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue